import React, { useState, useContext } from 'react';
import { Container, Stack, TextField, Select, MenuItem, InputLabel, FormControl, Button, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ticketApi from '../../api/ticketApi';
import { AuthContext } from '../../auth/AuthContext';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function TicketCreatePageMobile() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [form, setForm] = useState({ oggetto:'', categoria:'', priorita:'', messaggio:'' });
  const [err, setErr] = useState(null);
  const CATEGORIE = ['ASSISTENZA','BUG','RICHIESTA_INTERNA','AMMINISTRATIVO'];
  const PRIORITA = ['BASSA','MEDIA','ALTA'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      await ticketApi.create(form);
      navigate('/tickets');
    } catch (e) {
      setErr(e.response?.data?.error || e.message || 'Errore creazione ticket');
    }
  };

  return (
    <Container>
      {err && <Alert severity="error">{err}</Alert>}
      <Stack spacing={2} sx={{ mt: 2 }}>
        <TextField label="Oggetto" name="oggetto" value={form.oggetto} onChange={handleChange} fullWidth />
        <FormControl fullWidth>
          <InputLabel>Categoria</InputLabel>
          <Select name="categoria" value={form.categoria} onChange={handleChange} label="Categoria">
            {CATEGORIE.map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel>Priorità</InputLabel>
          <Select name="priorita" value={form.priorita} onChange={handleChange} label="Priorità">
            {PRIORITA.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
          </Select>
        </FormControl>
        <TextField
          label="Messaggio iniziale"
          name="messaggio"
          value={form.messaggio}
          onChange={handleChange}
          multiline
          rows={4}
          fullWidth
        />
        <Button variant="contained" onClick={handleSubmit}>Crea Ticket</Button>
      </Stack>
    </Container>
  );
}